@if (loaded) {
  @for (integration of shownActiveIntegrations; track integration) {
    @if (integration.format === 'lock') {
      <tidy-row [alignLastItemRight]="true">
        <tidy-image
          [src]="'assets/img/integration-images/remote-lock.png'"
          class="title-size" />
        <tidy-text
          [title]="'RemoteLock'"
          [translate]="false" />
        <tidy-drop-down-menu class="drop-down-menu">
          @for (item of [{action: 'disableGuestReservationIntegration', label: 'Disable Integration'}]; track item) {
            <tidy-drop-down-menu-item
              (click)="dropDownMenuClicked(item.action, integration)">
              {{item.label}}
            </tidy-drop-down-menu-item>
          }
        </tidy-drop-down-menu>
      </tidy-row>
      <tidy-card>
        <tidy-card-button (action)="goToRemoteLockPage()">
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/padlock.svg'"
              class="header-size" />
            <tidy-text
              [body]="('Integrated Devices: ' | translate) + integratedDevicesCount" />
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
    }
    @if (integration.format === 'seam') {
      <tidy-row [alignLastItemRight]="true">
        <tidy-image
          [src]="'assets/img/integration-images/seam.png'"
          class="title-size" />
        <tidy-text
          [title]="'Smart Locks (Seam)'"
          [translate]="false" />
        <tidy-drop-down-menu class="drop-down-menu">
          @for (item of [{action: 'disableIntegration', label: 'Disable Integration'}]; track item) {
            <tidy-drop-down-menu-item
              (click)="disableIntegration(integration.integration.id)">
              {{item.label}}
            </tidy-drop-down-menu-item>
          }
        </tidy-drop-down-menu>
      </tidy-row>
      <tidy-card>
        <tidy-card-button (action)="goToConnectLocksPage()">
          <tidy-row class="vertical-align-center">
            @if (integration?.integration?.integration_data?.image_url) {
              <tidy-image
                [src]="integration?.integration?.integration_data?.image_url"
                class="header-size" />
            }
            @if (!integration?.integration?.integration_data?.image_url) {
              <tidy-image
                [src]="'assets/img/padlock.svg'"
                class="header-size" />
            }
            <tidy-text
              [body]="integration?.integration?.integration_data?.account_type_display_name ? ('Connected: ' + integration?.integration?.integration_data?.account_type_display_name) : 'Connected via Seam'" />
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
    }
    @if (integration.format === 'notification') {
      <tidy-row class="vertical-align-center" style="margin-bottom: 5px">
        <tidy-image
          [src]="'assets/img/integration-images/' + integration?.integration?.channel + '.svg'"
          class="header-size" />
        <tidy-text
          [title]="integration?.integration?.channel === 'webhook' ? 'Webhook' : 'Slack'"
          [translate]="false" />
      </tidy-row>
      <tidy-card>
        <tidy-card-button (action)="goToAccountNotificationsPage()" class="arrow-to-top">
          @if (integration?.integration?.customer_account_team) {
            <tidy-row>
              <tidy-text
                [body]="'Group: '" />
              <tidy-text
                [body]="integration?.integration?.customer_account_team?.name"
                [translate]="false" />
            </tidy-row>
          }
          <tidy-row>
            <tidy-text
              [body]="integration?.integration?.webhook_url"
              [translate]="false" />
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
    }
    @if (integration.format !== 'notification' && integration.format !== 'lock' && integration.format !== 'seam') {
      <tidy-row [alignLastItemRight]="true" style="margin-bottom: -5px">
        @if (integration?.guest_reservation_source_type?.format === 'api') {
          <tidy-image
            [src]="'assets/img/gold-link.svg'"
            class="header-size" />
        }
        @if (integration?.guest_reservation_source_type?.format === 'concierge_integration') {
          <tidy-image
            [src]="'assets/img/concierge.svg'"
            class="header-size" />
        }
        @if (integration?.guest_reservation_source_type?.format === 'icalendar') {
          <tidy-image
            [src]="'assets/img/ical.png'"
            class="header-size" />
        }
        <tidy-text
          [title]="integration.guest_reservation_source_type?.name | titlecase" /><span>&nbsp;</span>
          @if (integration?.guest_reservation_source_type?.format === 'api') {
            <tidy-text
              [smallBody]="'(Direct Integration)'" />
          }
          @if (integration?.guest_reservation_source_type?.format === 'concierge_integration') {
            <tidy-text
              [smallBody]="'(Concierge Integration)'" />
          }
          @if (integration?.guest_reservation_source_type?.format === 'icalendar') {
            <div class="vertical-align-center">
              <tidy-text
                [smallBody]="'(iCal Integration)'" />
              @if (integration?.url) {
                <tidy-image
                  [src]="'assets/img/information-circle-grey.svg'"
                  class="small-body-size"
                  style="margin-left: 5px"
                  [matTooltip]="integration?.url | translate" />
              }
            </div>
          }
          <tidy-drop-down-menu class="drop-down-menu">
            @for (item of [{action: 'viewDocumentation', label: 'View Documentation'}, {action: 'disableGuestReservationIntegration', label: 'Disable Integration'}]; track item) {
              <!-- The TIDY (direct-booking) source can't be deactivated — unpublish the listing instead. -->
              @if (item.action !== 'disableGuestReservationIntegration' || !integration.is_tidy_source) {
                <tidy-drop-down-menu-item
                  (click)="dropDownMenuClicked(item.action, integration)">
                  {{item.label}}
                </tidy-drop-down-menu-item>
              }
            }
          </tidy-drop-down-menu>
        </tidy-row>
        @if (integration.state === 'paused') {
          <tidy-alert>
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/action-needed.svg'"
                class="header-size" />
              <tidy-text
                header="Issue Syncing" />
            </tidy-row>
            <tidy-row class="extra-bottom-padding">
              <tidy-text
                body="There was an issue syncing this integration. Please update your integration details:" />
            </tidy-row>
            <tidy-card-button (action)="goToUpdateIntegration(integration)">
              <tidy-row class="vertical-align-center">
                <tidy-text
                  [body]="'Update Integration Details'" />
              </tidy-row>
            </tidy-card-button>
          </tidy-alert>
        }
        @if (integration.state !== 'paused') {
          <tidy-card>
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/sync.svg'"
                class="header-size" />
              <tidy-text
                [header]="'Synced Data'" />
            </tidy-row>
            @if (integration?.guest_reservation_source_type?.format !== 'concierge_integration') {
              @if (!integration.last_sync_at && integration?.guest_reservation_fetch_status === 'pending' && integration.addresses.length <= 0) {
                <tidy-row>
                  <tidy-text
                    smallBody="Sync Pending.." />
                </tidy-row>
              }
              @if (!integration.last_sync_at && integration?.guest_reservation_fetch_status === 'pending' && integration.addresses.length > 0) {
                <tidy-row>
                  <tidy-text
                    smallBody="Syncing guest reservations.." />
                </tidy-row>
              }
            }
            @if (integration?.address_automatic_booking_setting && integration.addresses.length > 0) {
              <tidy-row class="vertical-align-center">
                <tidy-text
                  [smallBody]="'We are automatically syncing reservations from'" /><span>&nbsp;</span>
                  @if (integration?.guest_reservation_source_type?.format === 'icalendar') {
                    <tidy-text
                      [smallBody]="'1'" /><span>&nbsp;</span>
                      <tidy-text
                        [smallBody]="'property'" />
                    }
                    @if (integration?.guest_reservation_source_type?.format ==='api') {
                      <tidy-text
                        [smallBody]="integration?.addresses?.length" /><span>&nbsp;</span>
                        @if (integration?.guest_reservation_source_type?.format !== 'icalendar') {
                          <tidy-text
                            [smallBody]="'properties'" />
                        }
                      }
                      <tidy-image
                        [src]="'assets/img/information-circle-grey.svg'"
                        class="small-body-size"
                        style="margin-left: 5px"
                        [matTooltip]="getSyncedAddressesList(integration) | translate" />
                    </tidy-row>
                  }
                  @if (integration?.guest_reservation_source_type?.format !== 'concierge_integration') {
                    <tidy-card-button (action)="startSyncReservation(integration?.id)">
                      <tidy-row class="vertical-align-center">
                        <tidy-text
                          [body]="'Sync Reservation Data'" /><span>&nbsp;</span>
                          @if (integration.last_sync_at) {
                            <tidy-text
                              smallBody="(" />
                            <tidy-text
                              smallBody="last synced " /><span>&nbsp;</span>
                              <tidy-text
                                [smallBody]="(integration.last_sync_at | parseDateTime: 'MMM d') + ')'" />
                            }
                          </tidy-row>
                        </tidy-card-button>
                      }
                      @if (integration?.guest_reservation_source_type?.format !== 'icalendar') {
                        <tidy-card-button (action)="goToIntegrationSettings(integration)">
                          <tidy-row class="vertical-align-center">
                            <tidy-text
                              [body]="'Sync Settings'" />
                          </tidy-row>
                        </tidy-card-button>
                      }
                    </tidy-card>
                    <tidy-card>
                      <tidy-row class="vertical-align-center">
                        <tidy-image
                          [src]="integration?.guest_reservation_source_type?.format === 'icalendar' ? 'assets/img/suitcase.svg' : (integration?.address_automatic_booking_setting?.automatic_booking_enabled ? 'assets/img/search-calendar-enabled.svg' : 'assets/img/search-calendar-disabled.svg')"
                          class="header-size" />
                        <tidy-text
                          [header]="'Auto-Schedule'" />
                      </tidy-row>
                      <tidy-row>
                        <tidy-text
                          [smallBody]="'TIDY can automatically book a job for your pros when a reservation is synced.'" />
                      </tidy-row>
                      @if (integration?.guest_reservation_source_type?.format !== 'icalendar') {
                        <tidy-row class="vertical-align-center">
                          <tidy-text
                            [smallBody]="autoScheduleEnabledCount" /><span>&nbsp;</span>
                          <tidy-text
                            [smallBody]="'properties have auto-schedule on'" />
                        </tidy-row>
                        <tidy-card-button (action)="goToAutomaticBooking()">
                          <tidy-row class="vertical-align-center">
                            <tidy-text
                              [body]="'Auto-Schedule Settings'" />
                          </tidy-row>
                        </tidy-card-button>
                      }
                      @if (integration?.guest_reservation_source_type?.format === 'icalendar') {
                        <tidy-card-button (action)="goToAutomaticBookingAddress(integration)">
                          <tidy-row class="vertical-align-center">
                            <tidy-text
                              [body]="('Edit Auto-Schedule Settings ' | translate) + (integration?.address_automatic_booking_setting?.automatic_booking_enabled ? ('(ON)' | translate) : ('(OFF)' | translate))" />
                          </tidy-row>
                        </tidy-card-button>
                      }
                    </tidy-card>
                    @if (integration?.workflows?.length > 0) {
                      <tidy-card>
                        <tidy-row class="vertical-align-center">
                          <tidy-image
                            [src]="'assets/img/web-programming.svg'"
                            class="header-size" />
                          <tidy-text
                            [header]="integration.guest_reservation_source_type?.name | titlecase" /><span>&nbsp;</span>
                            <tidy-text
                              [header]="'Workflows'" />
                          </tidy-row>
                          @for (workflow of integration?.workflows; track workflow) {
                            <tidy-card-button (click)="goToWorkflow($event, workflow.id)" class="vertical-align-center">
                              <tidy-toggle
                                [toggled]="!workflow.paused_at"
                                (toggleChanged)="pauseUnpauseWorkflow($event, workflow)"
                                style="margin-right: 5px" />
                              <tidy-row class="vertical-align-center">
                                <tidy-text
                                  [body]="workflow.name" />
                              </tidy-row>
                            </tidy-card-button>
                          }
                        </tidy-card>
                      }
                      @if (integration?.workflowTemplates?.length > 0) {
                        <tidy-card>
                          <tidy-row class="vertical-align-center">
                            <tidy-image
                              [src]="'assets/img/web-programming.svg'"
                              class="header-size" />
                            <tidy-text
                              [header]="integration.guest_reservation_source_type?.name | titlecase" /><span>&nbsp;</span>
                              <tidy-text
                                [header]="'Workflow Templates'" />
                            </tidy-row>
                            @for (workflow of integration?.workflowTemplates; track workflow) {
                              <tidy-card-button (action)="goToWorkflowTemplatePage(workflow)">
                                <tidy-row class="vertical-align-center">
                                  <tidy-text
                                    [body]="workflow.name" />
                                </tidy-row>
                              </tidy-card-button>
                            }
                          </tidy-card>
                        }
                      }
                    }
                  }
                }